import React, { Component } from 'react';

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

//Material UI Components
import AppBar from "@material-ui/core/AppBar";
import { Grid } from '@material-ui/core';
import { Toolbar } from '@material-ui/core';
import { Pie, PieChart, Cell, Tooltip } from 'recharts';

// Engage Actions 
import { GetAllDashboardRepairsV2, GetAllDashboardDinningV2, GetAllDashboardActivitiesV2 } from '../../actions/dashboardAction';
import { getAllCommunities, getCommunityById } from '../../actions/communityActions';
import {SyncWorkOrdersTelsAndWorxHubs} from '../../actions/WorkOrderAction'

//Engage Components
import { SuperUserDropDown } from '../../components/SuperUserDropDown/SuperUserDropDown';
import { SwitchTwoOptions } from '../../utils/engageComponents';
import Wrench from '../../assets/svgs/wrench';
import CheckDouble from '../../assets/svgs/check-double';
import Eye from '../../assets/svgs/eye';
import Utensils from '../../assets/svgs/utensils';
import ClipboardList from '../../assets/svgs/clipboard-list';
import UserCheck from '../../assets/svgs/user-check';




class DashboardV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openWeekView: false,
            actualCommunityId: undefined,
            //Community
            superUserCommunitySelected: undefined,
            superUserActivitiesLoaddedForCommunity: undefined,
            //superUserCombo
            openCommunityCombo: false,
            syncWorkOrders: false,
        }
    };



    //#region  LifeCicle Methods
    componentDidMount() {
        document.title='Dashboard'
        this.GetDashboard();

        if (!this.props.communityData || (this.props.communityData && this.props.communityData.length === 0)) {
            this.GetAllCommunities();
        }

        setTimeout(() => {
            this.setState({ openModal: true })
        }, 400);

    }
    //#endregion

    //#region 

    GetAllCommunities = () => {
        if (localStorage.getItem('superAdmin') === "false") {
            this.props.getCommunityById(localStorage.getItem('communityId'))
        }
        else {
            this.props.getAllCommunities()
        }

    };


    GetDashboard = () => {
        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : '';

        if(!this.state.syncWorkOrders){
            this.setState({syncWorkOrders: true},  async() =>{
                await this.syncWorkOrdersProcess()  
            
                this.props.GetAllDashboardActivitiesV2(communityId);
                this.props.GetAllDashboardDinningV2(communityId);
                this.props.GetAllDashboardRepairsV2(communityId);
            })
        }

        this.setState({ actualCommunityId: communityId });
    }

    GetCommunityObjectForSupuerUserCombo(communityId) {
        let communityObj = null;
        if (this.props.communityData) {

            communityObj = this.props.communityData.find(item => item.communityId === communityId);
        }

        return communityObj;
    };
    handleCommunityCombo = () => {
        this.setState((prevState) => ({ openCommunityCombo: !prevState.openCommunityCombo }));
    }
    handleCommunityOnBlur = () => {
        this.setState({ openCommunityCombo: false })
    }
    //#endregion

    localStorageRemoveItem = (key) => {
        try {
            if (key) {
                localStorage.removeItem(key);
            }

        } catch (err) { }
    };

    localStorageSetItem = (key, value) => {
        try {
            if (key && value) {
                this.setState({openWeekView: false,});
                localStorage.setItem(key, value);
            }
        } catch (err) { }
    };

    setLocalState = (objectToSet) => {
        try {
            this.setState({ ...objectToSet , syncWorkOrders: false}, () =>{
                this.GetDashboard();
            })
        } catch (err) { }
    };

    ToggleScaleSelected = (optionselected) => {
        this.setState({ openWeekView: (optionselected === 0) ? false : true }, this.GetDashboard());
    }

    syncWorkOrdersProcess = async() =>{
        try{
            let res = undefined;
            const communityId = (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0) ? localStorage.getItem('communityId') : '';
            if(this.props && this.props.SyncWorkOrdersTelsAndWorxHubs && communityId){
                res = await  this.props.SyncWorkOrdersTelsAndWorxHubs(communityId);
            }   

            return res;
        }catch(err){
            return undefined
        }
    }

    render() {

        const communityId = (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0) ? localStorage.getItem('communityId') : '';

        const newStatusOpenRedirectionModal = (this.props.communityData && Array.isArray(this.props.communityData) && this.props.communityData.length > 0) ? false : true;
        const oldStatusOpenRedirectionModal = !!this.state.openRedirectModal;

        if (newStatusOpenRedirectionModal !== oldStatusOpenRedirectionModal) {
            this.setState({ openRedirectModal: newStatusOpenRedirectionModal });
        }

        //const communitySelected = (communityId && this.props && this.props.communityData && this.props.communityData.length > 0) ? this.props.communityData.find(comm => comm.communityId === communityId) : undefined;

        const isSuperAdmin = localStorage.getItem('superAdmin') ? (localStorage.getItem('superAdmin') === "true") : false;

        if (isSuperAdmin
            && this.props.communityData
            && this.props.communityData.length > 0
            && localStorage.getItem('communityId')
            && localStorage.getItem('communityId').length > 0
            && this.state.superUserCommunitySelected === undefined
        ) {
            this.setState({ superUserCommunitySelected: this.GetCommunityObjectForSupuerUserCombo(localStorage.getItem('communityId')) });
        }

        if (
            (
                this.state.superUserCommunitySelected &&
                (
                    !this.state.superUserActivitiesLoaddedForCommunity ||
                    (this.state.superUserActivitiesLoaddedForCommunity !== this.state.superUserCommunitySelected)
                )
            ) ||
            (
                this.state.superUserCommunitySelected === undefined &&
                this.state.superUserActivitiesLoaddedForCommunity !== undefined
            )
        ) {

            this.GetDashboard(communityId);
            this.setState({ superUserActivitiesLoaddedForCommunity: this.state.superUserCommunitySelected });
        }



        let repairData = {}, diningData = {}, activityData = {};

        if (this.props.isSuccess) {
            //(this.props.dashboardRepairsData && this.props.dashboardRepairsData) ? this.props.dashboardRepairsData : {};
            if (this.props.dashboardRepairsData) {
                if (!this.state.openWeekView)
                    repairData = this.props.dashboardRepairsData.Month
                else
                    repairData = this.props.dashboardRepairsData.Week
            }

            if (this.props.dashboardDiningData) {
                if (!this.state.openWeekView)
                    diningData = this.props.dashboardDiningData.Month
                else
                    diningData = this.props.dashboardDiningData.Week
            }

            if (this.props.dashboardActivitiesData) {
                if (!this.state.openWeekView)
                    activityData = this.props.dashboardActivitiesData.Month
                else
                    activityData = this.props.dashboardActivitiesData.Week
            }
        }

        //#region graph`s activity

        const renderCustomizedLabel = ({
            cx, cy, midAngle, innerRadius, outerRadius, value
        }) => {

            const z = 1.5;
            const RADIAN = Math.PI / 180;
            const radius = innerRadius + (outerRadius - innerRadius) * z;
            const x = cx + radius * Math.cos(-midAngle * RADIAN);
            const y = cy + radius * Math.sin(-midAngle * RADIAN);

            return (
                <text x={x} y={y} fill="white" fontSize='15px' fontFamily='Gotham-Bold' textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                    {`${value.toFixed(0)} % `}
                </text>
            );

        };

        const CustomTooltip = ({ active, payload }) => {

            if (active) {
                return (
                    <p className="GraphicTooltip">{`${payload[0].name} : ${payload[0].value}%`}</p>
                );
            }

            return null;
        };


        const generarLetra = () => {
            var letras = ["a", "b", "c", "d", "e", "f", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
            var numero = (Math.random() * 15).toFixed(0);
            return letras[numero];
        }

        const colorHEX = () => {
            var coolor = "";
            for (var i = 0; i < 6; i++) {
                coolor = coolor + generarLetra();
            }
            return "#" + coolor;
        }

        const COLORS = [
            '#349ce3', '#8f44f4', '#d35e70', '#5cd97b', '#dfd708',
            '#b0aeaf', '#84d4f4', '#549c64', '#3e76e4', '#a494b4',
            '#54478c', '#2c699a', '#f29e4c', '#048ba8', '#efea5a',
            '#0db39e', '#16db93', '#ffa69e', '#1a4301', '#49111c',
            '#007200', '#008bf8', '#d62828', '#14213d', '#3a0ca3',
            '#48bfe3', '#43aa8b', '#4d194d', '#c9ada7', '#370617'
        ];

        //#endregion

        const RenderActivityCategoryDashboard = () => {

            const categoryData = activityData ? activityData.categoryQty : undefined;
            const data = [];

            if (categoryData !== undefined) {

                if (categoryData.length > 30) {

                    for (let i = 0; i < categoryData.length - 30; i++) {
                        COLORS.push(colorHEX());
                    }

                }

                categoryData.forEach((item, index) => {
                    let obj = {

                        name: item.name,
                        value: Math.round(item.percentage),
                        color: COLORS[index]
                    }
                    data.push(obj);
                });

            }

            return (
                <Grid container item xs={12} alignItems='center' justify='center' direction='column' >
                    {
                        (data !== undefined) ?

                            <Grid item container xs={12} alignItems='center' justify='center' id='repairPage_HistoricalChart'>
                                <PieChart xs={12} width={550} height={400} item>
                                    <Pie
                                        data={data}
                                        cx='50%'
                                        cy='50%'
                                        startAngle={90}
                                        endAngle={-270}
                                        innerRadius={120}
                                        outerRadius={150}
                                        fill="#8884d8"
                                        paddingAngle={0}
                                        label={renderCustomizedLabel}
                                        labelLine={false}
                                    >
                                        {
                                            data.map((item, index) =>
                                                <Cell key={`cell-${index}`} fill={COLORS[index]} stroke={COLORS[index]} />
                                            )
                                        }
                                    </Pie>
                                    <Tooltip content={CustomTooltip} />
                                </PieChart>

                                {
                                    data.map((item, index) =>
                                        <Grid key={index} item container>
                                            <Grid container direction='row' alignItems='center' justify='center' style={{ marginBottom: '5px' }}>
                                                <Grid item style={{ borderRadius: '10px', height: '15px', width: '15px', backgroundColor: (item.color) }}></Grid>
                                                <Grid item className="GraphicLabels" xs={4} id='repairPage_HistoricalChart_Name'>{item.name} </Grid>
                                                <Grid item className="GraphicLabels" xs={2} id='repairPage_HistoricalChart_Value'>{item.value + '%'} </Grid>
                                            </Grid>
                                        </Grid>
                                    )
                                }
                            </Grid>

                            :
                            <Grid>No data found</Grid>
                    }
                </Grid>
            );

        }

        const RenderRegisteredDashboard = () => {

            const dataRegisters = [];

            if (activityData) {
                let objRegisters = {

                    name: "Registered For 1+ Activities" ,
                    value: Math.round(activityData.peopleRegisteredPercentage),
                    color: COLORS[3]
                }
                dataRegisters.push(objRegisters);

                objRegisters = {

                    name: "No Activity Registrations",
                    value: Math.round(activityData.peopleUnRegisteredPercentage),
                    color: COLORS[5]
                }
                dataRegisters.push(objRegisters);
            }

            return (
                <Grid container item xs={12} alignItems='center' direction='column' >
                    {
                        (dataRegisters !== undefined) ?

                            <Grid item container xs={12} alignItems='center' id='repairPage_HistoricalChart'>
                                <PieChart xs={12} width={550} height={400} item>
                                    <Pie
                                        data={dataRegisters}
                                        cx='50%'
                                        cy='50%'
                                        startAngle={90}
                                        endAngle={-270}
                                        innerRadius={120}
                                        outerRadius={150}
                                        fill="#8884d8"
                                        paddingAngle={0}
                                        label={renderCustomizedLabel}
                                        labelLine={false}
                                    >
                                        {
                                            dataRegisters.map((item, index) =>
                                                <Cell key={`cell-${index}`} fill={item.color} stroke={item.color} />

                                            )
                                        }
                                    </Pie>
                                    <Tooltip content={CustomTooltip} />
                                </PieChart>

                                {
                                    dataRegisters.map((item, index) =>
                                        <Grid key={index} item container>
                                            <Grid container direction='row' alignItems='center' justify='center' style={{ marginBottom: '5px' }}>
                                                <Grid item style={{ borderRadius: '10px', height: '15px', width: '15px', backgroundColor: (item.color) }}></Grid>
                                                <Grid item className="GraphicLabels" xs={5} id='repairPage_HistoricalChart_Name'>{item.name} </Grid>
                                                <Grid item className="GraphicLabels" xs={2} id='repairPage_HistoricalChart_Value'>{item.value + '%'} </Grid>
                                            </Grid>
                                        </Grid>
                                    )
                                }
                            </Grid>

                            :
                            <Grid>No data found</Grid>
                    }
                </Grid>
            );
        }

        return (
            <React.Fragment>
                <AppBar position="static" className="dark">
                    <Toolbar>
                        <Grid item container xs={12} alignItems='center' justifyContent='space-between'>
                        <Grid item container xs={12} sm={8} md={8} lg={8} direction='row' justify='flex-end' alignItems='center'>
                            <Grid item container xs={12} sm={9} md={9} lg={6} style={{ paddingTop: '10px' }}>
                                <SwitchTwoOptions
                                    idToSet='scheduler_switch_two_options'
                                    leftOptionLabel='LAST 30 DAYS'
                                    rightOptionLabel='LAST 7 DAYS'
                                    selectedOption={this.state.openWeekView === false ? 0 : 1}
                                    onOptionChange={(optionselected) => this.ToggleScaleSelected(optionselected)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={3} lg={6} style={{paddingLeft:'1rem', fontSize:'16px', fontFamily:'Gotham-Book'}}>(Includes current day)</Grid>
                        </Grid>
                        <Grid item container xs={12} sm={4} md={4} lg={4} className='globalActions' >
                            <Grid item container className='appbtn-list-engage globalActions' justify='flex-end' alignItems='center'>
                                <Grid item container xs={12} justify='flex-end' alignItems='center'>
                                    {
                                        (isSuperAdmin && isSuperAdmin === true) ?
                                            <Grid item container xs={12} style={{ paddingLeft: '15px', marginRight: '15px' }} justify='center' alignContent='center' >
                                                <SuperUserDropDown
                                                    stateOpen={this.state.open}
                                                    localStorageSetItem={this.localStorageSetItem}
                                                    localStorageRemoveItem={this.localStorageRemoveItem}
                                                    //SetHeaderButtons = {this.SetHeaderButtons}
                                                    handleCommunityCombo={this.handleCommunityCombo}
                                                    setState={this.setLocalState}
                                                    communityData={this.props.communityData}
                                                    superUserCommunitySelected={this.state.superUserCommunitySelected}
                                                    openCommunityCombo={this.state.openCommunityCombo}
                                                    handleCommunityOnBlur={this.handleCommunityOnBlur}
                                                />
                                            </Grid>
                                            :
                                            undefined

                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        </Grid>
                     
                    </Toolbar>
                </AppBar>

                <main className="content-engage">
                    <Grid container className='globalActions' >
                        {/* REPAIR DASHBOARD SECTION */}
                        <Grid item container xs={12} alignItems='flex-start'>
                            <Grid item container alignItems='center' className="DashboardBoxGroup">
                                <Grid item container xs={12}><h1>Repairs Totals</h1></Grid>
                                <Grid className="DashboardBox">
                                    <Grid container justify='space-around' alignItems='center' id='repairPage_Image' >
                                        <Wrench className="dashboardIcon redIcon" />
                                        <Grid className="dashboardNumber redText" id='repairPage_Count'>
                                            {
                                                (repairData && repairData.total) ?
                                                    repairData.total.count :
                                                    '0'
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className="dashboardTotals redText" id='repairPage_Name'> Total Opened</Grid>
                                </Grid>
                                <Grid className="DashboardBox">
                                    <Grid container justify='space-around' alignItems='center' id='repairPage_Image' >
                                        <CheckDouble className="dashboardIcon whiteIcon" />
                                        <Grid className="dashboardNumber" id='repairPage_Count'>
                                            {
                                                (repairData && repairData.close) ?
                                                    repairData.close.count :
                                                    '0'
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className="dashboardTotals whiteText" id='repairPage_Name'> Total Completed</Grid>
                                </Grid>
                            </Grid>
                            <Grid item container alignItems='center' className="DashboardBoxGroup">
                                <Grid className="DashboardListTitle"><h1>Most Common Repair Requests</h1></Grid>
                                <Grid className="DashboardBoxList">
                                    {
                                        repairData && repairData.list ?
                                            repairData.list.map(
                                                (repairData, index) => {
                                                    return (
                                                        <Grid className='TestStyle iconTestStyle'>
                                                            <Grid container justify='space-around' alignItems='center' id='repairPage_Image' >
                                                                <img
                                                                    alt={repairData._id.name}
                                                                    id="Add_Activity_Theme_Image_Exercise"
                                                                    className='dashboardImg'
                                                                    src={repairData._id.iconUrl}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} className="dashboardList" id='repairPage_Name'>
                                                                <span style={{ whiteSpace: "nowrap" }}>
                                                                    {repairData._id.name}
                                                                </span>
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                }
                                            )
                                            :
                                            undefined
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* DINING DASHBOARD SECTION */}
                        <Grid item container xs={12} alignItems='flex-start'>
                            <Grid item container alignItems='center' className="DashboardBoxGroup">
                                <Grid item container xs={12}><h1>Dining Totals</h1></Grid>
                                <Grid className="DashboardBox">
                                    <Grid container justify='space-around' alignItems='center' id='repairPage_Image' >
                                        <Eye className="dashboardIcon orangeIcon" />
                                        <Grid className="dashboardNumber orangeText" id='repairPage_Count'>
                                            {
                                                (diningData && diningData.avgView) ?
                                                    diningData.avgView :
                                                    '0'
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className="dashboardTotals orangeText" id='repairPage_Name'>Total Views</Grid>
                                </Grid>
                                <Grid className="DashboardBox">
                                    <Grid container justify='space-around' alignItems='center' id='repairPage_Image' >
                                        <Utensils className="dashboardIcon whiteIcon" />
                                        <Grid className="dashboardNumber" id='repairPage_Count'>
                                            {
                                                (diningData && diningData.created) ?
                                                    diningData.created :
                                                    '0'
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className="dashboardTotals whiteText" id='repairPage_Name'>Total Listed</Grid>
                                </Grid>
                            </Grid>
                            <Grid item container alignItems='center' className="DashboardBoxGroup">
                                <Grid className="DashboardListTitle"><h1>Most Viewed Menu Items</h1></Grid>
                                <Grid className="DashboardBoxList">
                                    {
                                        diningData && diningData.list ?
                                            diningData.list.map(
                                                (diningData, index) => {
                                                    return (
                                                        <Grid className='TestStyle'>
                                                            <Grid container justify='space-around' alignItems='center' id='repairPage_Image' >
                                                                <img
                                                                    alt={diningData.name}
                                                                    className='dashboardDiningImg'
                                                                    src={diningData.imageUrl}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} className="dashboardList" id='repairPage_Name'>
                                                                <span style={{ whiteSpace: "nowrap" }}>
                                                                    {diningData.name}
                                                                </span>
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                }
                                            )
                                            :
                                            undefined
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* ACTIVITIES DASHBOARD SECTION */}
                        <Grid item container xs={12} alignItems='flex-start'>
                            <Grid item container alignItems='center' className="DashboardBoxGroup">
                                <Grid item container xs={12}><h1>Activities Totals</h1></Grid>
                                <Grid className="DashboardBox">
                                    <Grid container justify='space-around' alignItems='center' id='repairPage_Image' >
                                        <Eye className="dashboardIcon greenIcon" />
                                        <Grid className="dashboardNumber greenText" id='repairPage_Count'>
                                            {
                                                (activityData && activityData.views) ?
                                                    activityData.views :
                                                    '0'
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className="dashboardTotals greenText" id='repairPage_Name'>Total Views</Grid>
                                </Grid>
                                <Grid className="DashboardBox">
                                    <Grid container justify='space-around' alignItems='center' id='repairPage_Image' >
                                        <ClipboardList className="dashboardIcon whiteIcon" />
                                        <Grid className="dashboardNumber" id='repairPage_Count'>
                                            {
                                                (activityData && activityData.total) ?
                                                    activityData.total :
                                                    '0'
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className="dashboardTotals whiteText" id='repairPage_Name'>Total Listed</Grid>
                                </Grid>
                                <Grid className="DashboardBox DashboardBoxBottom">
                                    <Grid container justify='space-around' alignItems='center' id='repairPage_Image' >
                                        <UserCheck className="dashboardIcon aquaIcon" />
                                        <Grid className="dashboardNumber aquaText" id='repairPage_Count'>
                                            {
                                                (activityData && activityData.peopleRegistered) ?
                                                    activityData.peopleRegistered :
                                                    '0'
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className="dashboardTotals dashboardTotals16 aquaText" id='repairPage_Name'>Residents Registered For Events</Grid>
                                </Grid>
                            </Grid>
                            <Grid item container alignItems='center' className="DashboardBoxGroup">
                                <Grid item container xs={12} className="DashboardListTitle"><h1>Most Viewed Activities</h1></Grid>
                                <Grid className="DashboardBoxList">
                                    {
                                        activityData && activityData.list ?
                                            activityData.list.map(
                                                (activityData, index) => {
                                                    return (
                                                        <Grid className='TestStyle'>
                                                            <Grid container justify='space-around' alignItems='center' id='repairPage_Image' >
                                                                <img
                                                                    alt={activityData.name}
                                                                    className='dashboardDiningImg'
                                                                    src={activityData.imageUrl}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} className="dashboardList" id='repairPage_Name'>
                                                                <span style={{ whiteSpace: "nowrap" }}>
                                                                    {activityData.name}
                                                                </span>
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                }
                                            )
                                            :
                                            undefined
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* GRAPH`S SECTION */}
                        <Grid item container xs={12} alignItems='flex-start' className="DashboardBoxGroup DashboardBoxGroupFooter">
                            <Grid item container alignItems='center' className="DashboardBoxGroup DashboardBoxGroup-Graphs">
                                <Grid container item xs={12}>
                                    <h1 className="graphTitles">Activities Per Category</h1>
                                </Grid>
                                <RenderActivityCategoryDashboard />
                            </Grid>
                            {/* Registeer per category*/}
                            <Grid item container alignItems='center' className="DashboardBoxGroup DashboardBoxGroup-Registeers DashboardBoxGroup-Graphs">
                                <Grid container item xs={12} >
                                    <h1>Registrations Per Category</h1>
                                </Grid>
                                <Grid container className="closedRepairs">
                                    {
                                        (activityData && activityData.categoryRegisters && activityData.categoryRegisters.length > 0) ?

                                            <Grid container item xs={12}>
                                                <Grid className='DashboardCategories-Titles' container xs={6} alignItems='center' justify='space-around' id='repairsPage_Item_ImageItem'>
                                                    Category
                                                </Grid>
                                                <Grid className='DashboardCategories-Titles' container xs={6} alignItems='center' justify='space-around' id='repairsPage_Item_ImageItem'>
                                                    Registrants
                                                </Grid>
                                            </Grid>
                                            :
                                            ""
                                    }

                                    {
                                        (activityData && activityData.categoryRegisters && activityData.categoryRegisters.length > 0) ?
                                            activityData.categoryRegisters.map((item, index) => {
                                                let itemName = item.name;
                                                if (itemName) {
                                                    itemName = itemName.charAt(0).toUpperCase() + itemName.slice(1);
                                                }
                                                if(item.registrees>0){
                                                    return (
                                                    
                                                        <Grid key={index} container xs={12} style={{ height: '126px', backgroundColor: (index % 2 === 0) ? 'transparent' : '#292929' }}>
                                                            <Grid container xs={6} alignItems='center' justify='space-around' id='repairsPage_Item_ImageItem'>
                                                                <img
                                                                    src={item.iconUrl}
                                                                    alt={itemName}
                                                                    className="ClosedRepairsIcon"
                                                                >
                                                                </img>
                                                                <Grid item xs={12} className="closedRepairsRowText">{itemName}</Grid>
                                                            </Grid>
                                                            <Grid container item xs={6} alignItems='center' justify='center' id='repairsPage_Item_count'>
                                                                <Grid item xs={12} className="closedRepairsNumberRequest">{item.registrees}</Grid>
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                }
                                                return(<></>)

                                            })
                                            :
                                            <Grid item xs={12} className="DashboardBoxNoInfo">No residents have registered for an activity</Grid>
                                    }
                                </Grid>
                            </Grid>
                            {/* Registeer percentage*/}
                            <Grid item container alignItems='center' className="DashboardBoxGroup DashboardBoxGroup-Graphs">
                                <Grid container item xs={12} >
                                    <h1 className="graphTitles">Registered Residents</h1>
                                </Grid>
                                <RenderRegisteredDashboard />
                            </Grid>
                        </Grid>
                    </Grid>
                </main>
            </React.Fragment>
        );
    }

}


function mapStateToProps(state) {

    let communityData = (state.communityReducer && state.communityReducer.communityData && Array.isArray(state.communityReducer.communityData) && state.communityReducer.communityData.length > 0) ? state.communityReducer.communityData.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId, worxHub: (item.worxHub && item.worxHub.active) ? item.worxHub.active : false })) : [];
    const dashboardRepairsData = (state.dashboardReducer && state.dashboardReducer.dashboardRepairsData) ? state.dashboardReducer.dashboardRepairsData : [];
    const dashboardDiningData = (state.dashboardReducer && state.dashboardReducer.dashboardDinningData) ? state.dashboardReducer.dashboardDinningData : [];
    const dashboardActivitiesData = (state.dashboardReducer && state.dashboardReducer.dashboardActivityData) ? state.dashboardReducer.dashboardActivityData : [];

    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }

    const isSuccess = state.dashboardReducer.success;

    return {
        communityData: communityData,
        dashboardRepairsData: dashboardRepairsData,
        dashboardDiningData: dashboardDiningData,
        dashboardActivitiesData: dashboardActivitiesData,
        isSuccess: isSuccess
    }
};

DashboardV2 = reduxForm({
    form: 'DashboardV2Form',
    enableReinitialize: true,
})(DashboardV2);


export default connect(mapStateToProps, { getAllCommunities, getCommunityById, GetAllDashboardRepairsV2, GetAllDashboardDinningV2, GetAllDashboardActivitiesV2, SyncWorkOrdersTelsAndWorxHubs })(DashboardV2)